import { KeyValue } from "@/main/models/common";
import { getTranslateByKey } from "@/main/services/utils";
import { z } from "zod";

const requiredMsg = (fieldKey: string) =>
	getTranslateByKey("information.isRequired", true).replace("{0}", getTranslateByKey(fieldKey));

const keyValueSchema = z.custom<KeyValue>();

const requiredKeyValue = (fieldKey: string) =>
	keyValueSchema.nullable().refine((v): v is KeyValue => v !== null, {
		error: () => requiredMsg(fieldKey),
	});

export const termsOfUseRegisterSchema = z.object({
	country: keyValueSchema.nullable(),
	systemApplication: requiredKeyValue("information.systemApplication"),
	companyType: requiredKeyValue("information.companyType"),
	company: z.array(keyValueSchema).min(1, {
		error: () => requiredMsg("information.company"),
	}),
	fileType: requiredKeyValue("information.term"),
	statusRegister: requiredKeyValue("information.status"),
	file: z.custom<File>().nullable(),
	culture: requiredKeyValue("information.userLanguage"),
});

export type ITermsOfUseRegisterForm = z.input<typeof termsOfUseRegisterSchema>;
export type ITermsOfUseRegisterFormOutput = z.output<typeof termsOfUseRegisterSchema>;

export const INITIAL_TERMS_OF_USE_REGISTER_FORM: ITermsOfUseRegisterForm = {
	country: null,
	companyType: null,
	company: [],
	systemApplication: null,
	fileType: null,
	statusRegister: null,
	file: null,
	culture: null,
};
